var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', {
    staticClass: "mb-4"
  }, [_c('b-card-title', {
    staticClass: "mb-4"
  }, [_vm._v("RELEVANTE LEVERINGEN")]), _c('dispatch-requests', {
    attrs: {
      "sales-order": _vm.salesOrder,
      "dispatch-requests": _vm.dispatchRequestsWithRequiredDecision,
      "hide-actions": true
    },
    scopedSlots: _vm._u([{
      key: "extraActions",
      fn: function (data) {
        return [_c('b-button', {
          staticClass: "mb-4 mb-xl-0",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.openDecisionModal(data.dispatchRequest);
            }
          }
        }, [_vm._v(" Vervolgactiekeuze ")])];
      }
    }])
  }), !_vm.dispatchRequestsWithRequiredDecision.length ? _c('p', [_c('i', [_vm._v("Deze order heeft op dit moment geen leveringen die een vervolgactiekeuze vereisen.")])]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "dispatch-request-decision-modal",
      "size": "xl",
      "centered": "",
      "hide-footer": "",
      "dialog-class": "shadow-none",
      "title": "Producten naleveren of crediteren"
    }
  }, [_c('final-dispatch-request-actions', {
    attrs: {
      "action": "add-extra-order-lines-and-refund-remaining",
      "sales-order": _vm.salesOrder,
      "override-dispatch-requests": [_vm.currentDispatchRequest],
      "is-modal": false
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }